import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DropDown from './ui/react-ui/dropdown';
import DataTable from './ui/table';
import SearchBar from './ui/searchBar';
import { getVessels } from '../api/statsAPI';
var t = i18n.getFixedT(null, 'vessels-dashboard');
var gt = i18n.getFixedT(null, 'app');
var VesselsDashboard = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var id = props.id;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentTerminalId = _useState2[0],
      setCurrentTerminalId = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      totalCount = _useState4[0],
      setTotalCount = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      keyword = _useState10[0],
      setKeyword = _useState10[1];

  var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      tableData = _useState12[0],
      setTableData = _useState12[1];

  var _useState13 = useState({
    field: 'berthTime',
    desc: false
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      tableSort = _useState14[0],
      setTableSort = _useState14[1];

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleGetVessels = function handleGetVessels() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getVessels(contextRoot, false, currentTerminalId, keyword, tableSort, offset, rowsPerPage).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  useEffect(function () {
    handleGetVessels();
  }, [keyword, JSON.stringify(tableSort), rowsPerPage, currentPage, currentTerminalId]);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'terminalName', {
    label: t('lbl-terminal-types'),
    sortable: true
  });

  _.set(fields, 'berthName', {
    label: t('lbl-berth-name'),
    sortable: true
  });

  _.set(fields, 'chtName', {
    label: t('lbl-chtName'),
    sortable: true
  });

  _.set(fields, 'enName', {
    label: t('lbl-enName'),
    sortable: true
  });

  _.set(fields, 'moveType', {
    label: t('lbl-move-type'),
    sortable: true,
    formatter: function formatter(val, row) {
      var toolTipTextStart = '';
      var toolTipTextEnd = ''; // let text = ''

      if (row.actWorkTime) {
        // text = t('lbl-working')
        toolTipTextStart = t('lbl-work-start') + moment(row.actWorkTime).format('HH:mm');
      }

      if (row.actCompletionTime) {
        // text = t('lbl-completed')
        toolTipTextEnd = t('lbl-work-end') + moment(row.actCompletionTime).format('HH:mm');
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "data-moteTpye"
      }, val, toolTipTextStart && /*#__PURE__*/React.createElement(Tooltip, {
        title: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, toolTipTextStart), /*#__PURE__*/React.createElement("div", null, toolTipTextEnd))
      }, /*#__PURE__*/React.createElement(InfoOutlinedIcon, null)));
    }
  });

  _.set(fields, 'berthTime', {
    label: t('lbl-berth-time'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (row.actBerthTime) return moment(val).format('YYYY-MM-DD HH:mm');else return /*#__PURE__*/React.createElement("div", null, moment(val).format('YYYY-MM-DD HH:mm'), /*#__PURE__*/React.createElement("span", null, t('lbl-time-predict'))); // // 實際停泊時間 actBerthTime;
      // if(row.actBerthTime)
      //     return moment(row.actBerthTime).format('YYYY-MM-DD HH:mm')
      // // 預測停泊時間 estBerthTime;
      // if(row.estBerthTime) {
      //     return (<div>
      //         { moment(row.estBerthTime).format('YYYY-MM-DD HH:mm') }
      //         <span>{t('lbl-time-predict')}</span>
      //     </div>)
      // }
    }
  });

  _.set(fields, 'estUnberthTime', {
    label: t('lbl-unberth-time'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (row.estUnberthTime) {
        return /*#__PURE__*/React.createElement("div", null, moment(row.estUnberthTime).format('YYYY-MM-DD HH:mm'), /*#__PURE__*/React.createElement("span", null, t('lbl-time-predict')));
      }
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "vessels-dashboard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-vessels-dashboard')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-terminals'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    className: "terminals-dropdown",
    defaultText: t('lbl-all-terminals'),
    list: terminalsList,
    value: currentTerminalId,
    onChange: function onChange(value) {
      setCurrentTerminalId(value);
      setCurrentPage(0);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search); // if(_.isEmpty(search))
      //     handleGetVessels()
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  })));
});
VesselsDashboard.defaultProps = {
  id: 'g-vessels-dashboard'
};
VesselsDashboard.PropTypes = {
  id: PropTypes.string
};
export default VesselsDashboard;